import cx from "clsx";
import DropdownMenu from "kreate-common/modules/kreate-ui/components/DropdownMenu";
import { useRouter } from "next/router";
import React from "react";
import {
  MdExplore,
  MdPermMedia,
  MdPhotoSizeSelectActual,
} from "react-icons/md";

import styles from "./index.module.scss";

import { useBusyCount } from "@/modules/common-hooks/useBusyCount";
import ButtonOnNavbar from "@/modules/kreate-components/components/NavbarV2/components/ButtonOnNavbar";
import {
  getLinkToPageExploreAssets,
  getLinkToPageExplorePolicies,
} from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function ButtonExplore({ className, style }: Props) {
  const router = useRouter();
  const { busy, withDefaultErrorHandler } = useBusyCount();

  return (
    <div className={cx(styles.container, className)} style={style}>
      <DropdownMenu.Menu
        trigger={
          <ButtonOnNavbar
            icon={<MdExplore />}
            content="Explore"
            loading={busy}
            disabled={busy}
          />
        }
      >
        <DropdownMenu.Item
          icon={<MdPhotoSizeSelectActual />}
          content="Assets"
          onSelect={withDefaultErrorHandler(async () => {
            await router.push(getLinkToPageExploreAssets(""));
          })}
        />
        <DropdownMenu.Item
          icon={<MdPermMedia />}
          content="Policies"
          onSelect={withDefaultErrorHandler(async () => {
            await router.push(getLinkToPageExplorePolicies(""));
          })}
        />
      </DropdownMenu.Menu>
    </div>
  );
}
